import React, { useEffect, useState } from "react";
import { HostedLookupTableContanier } from './Style';
import { Space, Popconfirm, Button, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import Topbar from 'components/UI/Topbar/Topbar';
import { Table } from 'components-shared/table/Table';
import { TableTop, TableWrapper } from 'components-shared/table/TableTop';
import { connect } from 'react-redux';
import hostedTablesActions from 'redux/hostedTables/actions';
import AddHostedLookupTable from './AddHostedLookupTable';
import EditHostedTable from './EditHostedTable';
import HostedTableInfo from './HostedTableInfo';
import Tabs from 'screens/Mapping/components/Tabs';

const isConversationTableEnabled = process.env.REACT_APP_CONVERSATION_TABLES;

export const HOSTED_TABLE_TABS = {
  TABLES: 'TABLES',
  CONVERSATIONAL_TABLES: 'CONVERSATIONAL_TABLES',
};

const HostedLookupTablesList = ({ init, tableNames, getHostedTablesConfig, deleteHostedTable, setEditForm, activeAccountId, conversationTableNames, uploadPopupVisible, setUploadPopupVisible, saveTableName }) => {

  const [activeTab, setTabActive] = useState(HOSTED_TABLE_TABS.TABLES);

  const [tableInfo, setTableInfo] = useState({
    showTableInfo: false,
    tableName: '',
    columnDescriptions: [],
  });

  useEffect(() => {
    getHostedTablesConfig();
  }, [activeAccountId]);

  const deleteTable = (record) => {
    deleteHostedTable(record.tableName, activeTab);
  };

  const handleTableInfo = (record) => {
    setTableInfo({
      showTableInfo: true,
      tableName: record.tableName,
      columnDescriptions: record.columnDescriptions,
    });
  };

  const columns = [
    {
      title: 'Table Name',
      dataIndex: 'tableName',
      ellipsis: true,
      width: '70%',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button onClick={() => setEditForm(record.tableName, true)} type="primary">Upload Data</Button>
          <Popconfirm
            title={`Are you sure to delete "${record.tableName}" table?`}
            onConfirm={() => deleteTable(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger>Delete</Button>
          </Popconfirm>
          <Tooltip title={`Table Structure of "${record.tableName}"`} placement="top">
            <span className="hosted-table-info" onClick={() => handleTableInfo(record)}>
              <InfoCircleOutlined />
            </span>
          </Tooltip>
        </Space>
      ),
    }
  ];

  const conversationalTableColumns = [
    {
      title: 'Table Name',
      dataIndex: 'tableName',
      ellipsis: true,
      width: '70%',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button onClick={() => {
            saveTableName({ tableName: record.tableName,isEdit: true, selectedTableData: record});
            setUploadPopupVisible(true);
          }} type="primary">Upload Data</Button>
          <Popconfirm
            title={`Are you sure to delete "${record.tableName}" table?`}
            onConfirm={() => deleteTable(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger>Delete</Button>
          </Popconfirm>
          <Tooltip title={`Table Structure of "${record.tableName}"`} placement="top">
            <span className="hosted-table-info" onClick={() => handleTableInfo(record)}>
              <InfoCircleOutlined />
            </span>
          </Tooltip>
        </Space>
      ),
    }
  ];

  return (
    <HostedLookupTableContanier>
      <Topbar title="Hosted Lookup Tables"><AddHostedLookupTable disabled={init} activeTab={activeTab} /></Topbar>

      <div style={{ marginTop: 20 }}>
        <Tabs.TabSwitcher activeTab={activeTab}>
          <div style={{ display: 'flex' }}>
            <Tabs.Tab setTabActive={setTabActive} id={HOSTED_TABLE_TABS.TABLES}>
              <button className={`mapping-tab ${activeTab === HOSTED_TABLE_TABS.TABLES && 'active'}`}>
                Custom Tables
              </button>
            </Tabs.Tab>
            {isConversationTableEnabled == 'true'  &&  
              <Tabs.Tab setTabActive={setTabActive} id={HOSTED_TABLE_TABS.CONVERSATIONAL_TABLES}>
              <button className={`mapping-tab ${activeTab === HOSTED_TABLE_TABS.CONVERSATIONAL_TABLES && 'active'}`}>
                Conversational Tables
              </button>
            </Tabs.Tab>
            }
            
          </div>

          <Tabs.TabPanel whenActive={HOSTED_TABLE_TABS.TABLES}>
            <TableWrapper>
              <TableTop>
                <p style={{ fontSize: 15 }}>Review, upload or delete hosted lookup tables.</p>
              </TableTop>
              <Table
                columns={columns}
                data={tableNames}
                rowKey="tableName"
                size="small"
                isLoading={init}
              />
            </TableWrapper>
          </Tabs.TabPanel>

          <Tabs.TabPanel whenActive={HOSTED_TABLE_TABS.CONVERSATIONAL_TABLES}>
            <TableWrapper>
              <TableTop>
                <p style={{ fontSize: 15 }}> Conversational tables.</p>
              </TableTop>
              <Table
                columns={conversationalTableColumns}
                data={conversationTableNames}
                rowKey="convtableName"
                size="small"
                isLoading={init}
              />
            </TableWrapper>
          </Tabs.TabPanel>

        </Tabs.TabSwitcher>
      </div>

      <EditHostedTable />
      {
        tableInfo.showTableInfo &&
        <HostedTableInfo
          tableInfo={tableInfo}
          setTableInfo={setTableInfo}
        />
      }
      {/* {
        uploadPopupVisible &&
        <UploadHostedLookupTable
          isVisible={uploadPopupVisible}
          activeTab={activeTab}
          isEdit={true}
          tableInfo={tableInfo}
        />
      } */}

    </HostedLookupTableContanier>
  );
};

const mapStatetoProps = (state) => ({
  activeAccountId: state.App.activeAccountId,
  init: state.hostedTables.init,
  step: state.hostedTables.step,
  tableNames: state.hostedTables.tableNames,
  conversationTableNames: state.hostedTables.conversationTableNames,
  uploadPopupVisible: state.hostedTables.uploadPopupVisible,

});

const mapDispathTopProps = (dispatch) => ({
  getHostedTablesConfig: () => dispatch(hostedTablesActions.getHostedTablesConfig()),
  deleteHostedTable: (tableName, type) => dispatch(hostedTablesActions.deleteHostedTable(tableName, type)),
  setEditForm: (tableName, isEditPopup) => dispatch(hostedTablesActions.setEditForm(tableName, isEditPopup)),
  setUploadPopupVisible: (uploadPopupVisible) => dispatch(hostedTablesActions.setUploadPopupVisible(uploadPopupVisible)),
  saveTableName: (data) => dispatch(hostedTablesActions.saveTableName(data))
});

export default connect(mapStatetoProps, mapDispathTopProps)(HostedLookupTablesList);
